export default "__VITE_ASSET__DomdaznT__"